import { EnterPendingRenewalStatusRequest } from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const enterPendingRenewalStatus = (
  req: Partial<EnterPendingRenewalStatusRequest>
): Promise<void> =>
  request({
    url: '/service/userv2service/EnterPendingRenewalStatus',
    body: req,
  }).then((r) => r.body);
